import BlogGrid from "../components/grid/BlogGrid";

const Home = () => {
  return (
    <section className="wrapper">
      <BlogGrid />
    </section>
  );
};

export default Home;
